let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("58kAD"), load("7EorR"), load("6d83I")]).then(() => parcelRequire('2uezU'));